import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {UrandaUiModule} from '@uranda/ui';

import {NavbarComponent} from '../web/components/navbar/navbar.component';
import {HeaderComponent} from '../web/components/header/header.component';
import {SearchBarComponent} from '../web/components/searchbar/searchbar.component';
import {BannerComponent} from '../web/components/banner/banner.component';
import {WhyDentalTourComponent} from '../web/components/why-dental-tour/why-dental-tour.component';
import {CountryListComponent} from '../web/components/country-list/country-list.component';
import {SelectOffcanvasComponent} from '../web/components/select-offcanvas/select-offcanvas.component';
import {DragCloseDirective} from '../web/request/drag-close.directive';
import {CountryNamePipe} from './pipes/country-name.pipe';
import {PlaceNamePipe} from './pipes/place-name.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    UrandaUiModule,
    CountryNamePipe,
    PlaceNamePipe,
  ],
  declarations: [
    NavbarComponent,
    HeaderComponent,
    SearchBarComponent,
    BannerComponent,
    WhyDentalTourComponent,
    CountryListComponent,
    SelectOffcanvasComponent,
    DragCloseDirective,
  ],
  exports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    UrandaUiModule,
    NavbarComponent,
    HeaderComponent,
    SearchBarComponent,
    BannerComponent,
    WhyDentalTourComponent,
    CountryListComponent,
    SelectOffcanvasComponent,
    DragCloseDirective,
    PlaceNamePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PublicCoreModule {}

